
import { Component, Mixins, Watch } from "vue-property-decorator";
import { default as MediaReferableContentMixin } from "./MediaReferableContentMixin.vue";
import { ImageSourceKinds } from "../../../../../../../domain/document";
import { IItem } from "../../../../../../../domain/document/items";
import { ImageDrawableRotationAngleAccessor } from "../accessors";

@Component
export default class MediaRotatableContentMixin extends Mixins(MediaReferableContentMixin) {
  data() {
    return {
      accessor: null as ImageDrawableRotationAngleAccessor,
      error: "",
    };
  }
  accessor: ImageDrawableRotationAngleAccessor;
  error: string;

  get isEditable(): boolean {
    return this.imageDrawable.isEditable;
  }

  get isClearable(): boolean {
    return !!this.imageSource && (this.imageSource.imageSourceKind !== ImageSourceKinds.None)
      && !!this.imageSource.imageSourceKind;
  }

  get isFatal(): boolean {
    return !this.accessor;
  }

  mounted() {
    this.initialize(this.item);
  }

  @Watch("item")
  onItemUpdated(newValue: IItem) {
    this.initialize(newValue);
  }

  private initialize(newValue: IItem) {
    try {
      this.accessor = new ImageDrawableRotationAngleAccessor(newValue);
      this.accessor.validate();
      this.error = "";
    } catch (e) {
      this.accessor = null;
      this.error = e.message;
    }
  }

  rotateImage(offset: number = 90): void {
    const currentAngle = !!this.imageDrawable.rotationAngle ? this.imageDrawable.rotationAngle : 0;
    const rotatedAngle = Number(currentAngle) + offset;
    const nextAndle = (rotatedAngle >= 360) ? rotatedAngle - 360 : rotatedAngle;
    this.updateItem(this.accessor.set(nextAndle));
  }
}
